/**
 * Scroll to the visible product review carousel (gallery vs mobile slot).
 */
(function () {
  if (window.__reviewStarsLinkScrollBound) return;
  window.__reviewStarsLinkScrollBound = true;
  document.addEventListener(
    'click',
    function (e) {
      var trigger = e.target.closest('[data-scroll-product-reviews]');
      if (!trigger) return;
      var sectionId = trigger.getAttribute('data-product-section-id');
      if (!sectionId) return;
      e.preventDefault();
      var root = document.querySelector('#Product--' + sectionId);
      if (!root) return;
      var carousels = root.querySelectorAll('[data-product-reviews-carousel]');
      for (var i = 0; i < carousels.length; i++) {
        if (carousels[i].offsetParent !== null) {
          carousels[i].scrollIntoView({ behavior: 'smooth', block: 'start' });
          break;
        }
      }
    },
    false
  );
})();
